/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const calendar = (
	<SVG width="36" height="40" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M8 12C8 10.8954 8.89543 10 10 10H38C39.1046 10 40 10.8954 40 12V40C40 41.1046 39.1046 42 38 42H10C8.89543 42 8 41.1046 8 40V12Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M8 12C8 10.8954 8.89543 10 10 10H38C39.1046 10 40 10.8954 40 12V18H8V12Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M16 6V14"
			stroke="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
			strokeWidth="4"
			strokeLinecap="round"
		/>
		<Path
			d="M32 6V14"
			stroke="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
			strokeWidth="4"
			strokeLinecap="round"
		/>
		<Path d="M14 24H18V28H14V24Z" fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)" />
		<Path d="M22 24H26V28H22V24Z" fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)" />
		<Path d="M30 24H34V28H30V24Z" fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)" />
		<Path d="M14 32H18V36H14V32Z" fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)" />
		<Path d="M22 32H26V36H22V32Z" fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)" />

		<Path
			d="M0 11.5424V36.1275C0 38.5843 1.36201 39.998 3.76707 39.998H31.8175C34.2226 39.998 35.5846 38.5757 35.5846 36.1275V11.5424C35.5846 9.08564 34.2226 7.67191 31.8175 7.67191H3.76707C1.36201 7.66329 0 9.08564 0 11.5424Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M9.33551 25.7662C10.4303 25.7662 11.3527 24.8956 11.3527 23.7491C11.3527 22.6026 10.482 21.7319 9.33551 21.7319C8.18901 21.7319 7.31836 22.6026 7.31836 23.7491C7.31836 24.8956 8.18901 25.7662 9.33551 25.7662Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M17.7916 25.7662C18.8863 25.7662 19.8087 24.8956 19.8087 23.7491C19.8087 22.6026 18.9381 21.7319 17.7916 21.7319C16.6451 21.7319 15.7744 22.6026 15.7744 23.7491C15.7744 24.8956 16.7054 25.7662 17.7916 25.7662Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M26.2486 25.7662C27.3434 25.7662 28.2657 24.8956 28.2657 23.7491C28.2657 22.6026 27.3951 21.7319 26.2486 21.7319C25.1021 21.7319 24.2314 22.6026 24.2314 23.7491C24.2314 24.8956 25.1624 25.7662 26.2486 25.7662Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M9.33551 34.4298C10.4303 34.4298 11.3527 33.5592 11.3527 32.4127C11.3527 31.2662 10.482 30.3955 9.33551 30.3955C8.18901 30.3955 7.31836 31.2662 7.31836 32.4127C7.31836 33.5592 8.18901 34.4298 9.33551 34.4298Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M17.7916 34.4298C18.8863 34.4298 19.8087 33.5592 19.8087 32.4127C19.8087 31.2662 18.9381 30.3955 17.7916 30.3955C16.6451 30.3955 15.7744 31.2662 15.7744 32.4127C15.7744 33.5592 16.7054 34.4298 17.7916 34.4298Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M26.2486 34.4298C27.3434 34.4298 28.2657 33.5592 28.2657 32.4127C28.2657 31.2662 27.3951 30.3955 26.2486 30.3955C25.1021 30.3955 24.2314 31.2662 24.2314 32.4127C24.2314 33.5592 25.1624 34.4298 26.2486 34.4298Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M0 11.5424V16.1542H35.5846V11.5424C35.5846 9.0856 34.2226 7.67188 31.8175 7.67188H3.76707C1.36201 7.67188 0 9.09422 0 11.5424Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M26.8 0H25.4639C23.9898 0 23.1191 0.818928 23.1191 2.34472V10.2064C23.1191 11.6805 23.9381 12.5512 25.4639 12.5512H26.8C28.2741 12.5512 29.1447 11.7322 29.1447 10.2064V2.34472C29.1447 0.87065 28.3258 0 26.8 0Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M10.1115 0H8.77539C7.30131 0 6.43066 0.818928 6.43066 2.34472V10.2064C6.43066 11.6805 7.24959 12.5512 8.77539 12.5512H10.1115C11.5856 12.5512 12.4563 11.7322 12.4563 10.2064V2.34472C12.4563 0.87065 11.6373 0 10.1115 0Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
	</SVG>
);
